// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../../graphql/api/index';

export const QuestionnaireConditionEqualToChoiceFragmentDoc = `
    fragment questionnaireConditionEqualToChoice on QuestionnaireConditionEqualToChoice {
  __typename
  question {
    id
  }
  choice {
    id
  }
}
    `;